<template>
  <v-dialog v-model="value" scrollable persistent max-width="650px">
    <v-form
      ref="inviteForm"
      v-model="valid"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{dialogTitle}}</span>
        </v-card-title>
        <v-card-text class="pt-0" style="max-height: 450px;">
          <v-row>
            <v-col class="px-2" cols="6" v-if="moreDetails">
              <v-text-field
                v-model="contact.name.prefix"
                label="Prefix"
              ></v-text-field>
            </v-col>
            <v-col class="px-2" cols="6" >
              <v-text-field
                v-model="contact.name.first"
                label="First name"
              ></v-text-field>
            </v-col>
            <v-col class="px-2" cols="6" v-if="moreDetails" >
              <v-text-field
                v-model="contact.name.middle"
                label="Middle name"
              ></v-text-field>
            </v-col>
            <v-col class="px-2" cols="6" >
              <v-text-field
                v-model="contact.name.last"
                label="Last name"
              ></v-text-field>
            </v-col>
            <v-col class="px-2" cols="6" v-if="moreDetails" >
              <v-text-field
                v-model="contact.name.suffix"
                label="Suffix"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              v-for="(email, index) in contact.emailAddresses"
              :key="'email-'+index"
            >
              <ContactFormEmail
                v-if="visibleEmails.includes(index)"
                :email="contact.emailAddresses[index]"
                :moreDetails="moreDetails"
                :isLast="index===contact.emailAddresses.length-1"
                :index="index"
                @addBlankEmail="addBlankEmail"
                @removeEmail="removeEmail"
              />
            </v-col>
            <v-col
              cols="12"
              v-for="(phone, index) in contact.phoneNumbers"
              :key="'phone-'+index"
            >
              <ContactFormPhone
                v-if="visiblePhones.includes(index)"
                :phone="contact.phoneNumbers[index]"
                :moreDetails="moreDetails"
                :isLast="index===contact.phoneNumbers.length-1"
                :index="index"
                @addBlankPhone="addBlankPhone"
                @removePhone="removePhone"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="moreDetails === false" text @click="moreDetails = true">{{ $t('general.more_details') }}</v-btn>
          <v-btn v-else text @click="moreDetails = false">{{ $t('general.less_details') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="$emit('input', false)">{{ $t('buttons.close') }}</v-btn>
          <v-btn :disabled="notFilled" color="kazan" text @click="saveContact()">{{ $t('buttons.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ContactFormEmail from '@/components/contacts/ContactFormEmail'
import ContactFormPhone from '@/components/contacts/ContactFormPhone'
import { contactService } from '@/_services'
import { mapActions } from 'vuex'
import { generalHelpers } from '@/_helpers'

export default {
  name: 'ContactFormDialog',
  components: {
    ContactFormEmail,
    ContactFormPhone
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    contactID: {
      type: String,
      default: null
    },
    companyID: String
  },
  data () {
    return {
      valid: true,
      contact: null,
      fetchedContact: null,
      moreDetails: false,
      dialogTitle: '',
      removedEmails: [],
      removedPhones: []
    }
  },
  computed: {
    notFilled () {
      return (this.contact.emailAddresses.length === 1 && this.contact.emailAddresses[0].value === '' &&
              this.contact.name.first === '' && this.contact.name.last === '' &&
              this.contact.phoneNumbers.length === 1 && this.contact.phoneNumbers[0].value === '' &&
              this.contact.user_id === null)
    },
    visibleEmails () {
      let visible = []
      for (let i = 0; i < this.contact.emailAddresses.length; i++) {
        if (!this.removedEmails.includes(i)) {
          visible.push(i)
        }
      }
      return visible
    },
    visiblePhones () {
      let visible = []
      for (let i = 0; i < this.contact.phoneNumbers.length; i++) {
        if (!this.removedPhones.includes(i)) {
          visible.push(i)
        }
      }
      return visible
    }
  },
  methods: {
    ...mapActions({
      showSnackbar: 'showSnackbar',
      setLoadingTime: 'setLoadingTime'
    }),
    async saveContact () {
      let result = {}
      let isError = false
      if (this.contactID === null) { // create new contact
        result = await contactService.addContactInput(this.companyID, this.contact)
        if (result.err) { isError = true }
      } else { // edit contact
        if (!generalHelpers.isEqual(this.fetchedContact.name, this.contact.name)) { // contact name was changed
          result = await contactService.addContactInput(this.companyID, this.contact.id, this.contact.name)
          if (result.err) { isError = true }
        }
        if (this.fetchedContact.position !== this.contact.position) { // contact position was changed
          result = await contactService.addContactInput(this.companyID, this.contact.id, this.contact.position)
          if (result.err) { isError = true }
        }
        for (let i = 0; i < this.fetchedContact.emailAddresses.length; i++) { // check if some emails was removed
          if (this.removedEmails.includes(i)) {
            result = await contactService.removeContactEmailAddressInput(this.companyID, this.contact.id, this.fetchedContact.emailAddresses[i])
            if (result.err) { isError = true }
          }
        }
        for (let i = 0; i < this.visibleEmails.length; i++) { // check if some emails was added or changed (is visible and not empty)
          if (this.fetchedContact.emailAddresses[i] !== undefined && !generalHelpers.isEqual(this.fetchedContact.emailAddresses[i], this.contact.emails[i])) {
            let emails = {
              old: this.fetchedContact.emailAddresses[i],
              new: this.contact.emails[i]
            }
            result = await contactService.changeContactEmailAddressInput(this.companyID, this.contact.id, emails)
            if (result.err) { isError = true }
          } else if (this.fetchedContact.emailAddresses[i] === undefined && this.contact.emails[i].value !== '') {
            result = await contactService.addContactEmailAddressInput(this.companyID, this.contact.id, this.contact.emails[i])
            if (result.err) { isError = true }
          }
        }
        // -----
        for (let i = 0; i < this.fetchedContact.phoneNumbers.length; i++) { // check if some phonenumbers was removed
          if (this.removedPhones.includes(i)) {
            result = await contactService.removeContactEmailAddressInput(this.companyID, this.contact.id, this.fetchedContact.phoneNumbers[i])
            if (result.err) { isError = true }
          }
        }
        for (let i = 0; i < this.visiblePhones.length; i++) { // check if some phonenumbers was added or changed (is visible and not empty)
          if (this.fetchedContact.phoneNumbers[i] !== undefined && !generalHelpers.isEqual(this.fetchedContact.phoneNumbers[i], this.contact.phoneNumbers[i])) {
            let phones = {
              old: this.fetchedContact.phoneNumbers[i],
              new: this.contact.phoneNumbers[i]
            }
            result = await contactService.changeContactEmailAddressInput(this.companyID, this.contact.id, phones)
            if (result.err) { isError = true }
          } else if (this.fetchedContact.phoneNumbers[i] === undefined && this.contact.phoneNumbers[i].value !== '') {
            result = await contactService.addContactEmailAddressInput(this.companyID, this.contact.id, this.contact.phoneNumbers[i])
            if (result.err) { isError = true }
          }
        }
      }
      if (!isError) {
        // fake loader
        await this.setLoadingTime(2000)
        this.$emit('input', false)
        // send to parent info that need to fetch contacts again
        this.$emit('fetchNew')
      }
      this.createSnackbar(isError)
    },
    addBlankEmail () {
      this.contact.emailAddresses.push({ type: '', value: '' })
    },
    removeEmail (index) {
      this.removedEmails.push(index)
      if (this.visibleEmails.length === 0) {
        this.contact.emailAddresses.push({ type: '', value: '' })
      }
    },
    addBlankPhone () {
      this.contact.phoneNumbers.push({ type: '', value: '' })
    },
    removePhone (index) {
      this.removedPhones.push(index)
      if (this.visiblePhones.length === 0) {
        this.contact.phoneNumbers.push({ type: '', value: '' })
      }
    },
    clearContact () {
      this.contact = {
        emailAddresses: [],
        name: {
          first: '',
          last: '',
          middle: '',
          prefix: '',
          suffix: ''
        },
        phoneNumbers: [],
        user_id: null
      }
      this.addBlankEmail()
      this.addBlankPhone()
    },
    async fetchContact () {
      this.contact = await contactService.getContact(this.companyID, this.contactID)
      this.$set(this.contact, 'emailAddresses', this.contact.emails)
      this.fetchedContact = JSON.parse(JSON.stringify(this.contact)) // make copy of fetched contact

      // error when fetching contact
      if (this.contact.err) {
        let snackMsg = this.$i18n.t('snackbars.error')
        this.$emit('input', false)
        this.showSnackbar({ message: snackMsg, color: 'error' })
      }
    },
    createSnackbar (isError) {
      let snackMsg = ''
      let snackColor = ''
      if (isError) {
        snackMsg = this.$i18n.t('snackbars.error')
        snackColor = 'errorr'
      } else {
        if (this.contactID !== null) {
          snackMsg = this.$i18n.t('snackbars.contact_updated')
        } else {
          snackMsg = this.$i18n.t('snackbars.contact_created')
        }
        snackColor = 'success'
      }
      this.showSnackbar({ message: snackMsg, color: snackColor })
    }
  },
  created () {
    if (this.contactID !== null) {
      this.clearContact()
      this.fetchContact()
      this.dialogTitle = this.$i18n.t('companies.edit_contact')
    } else {
      this.clearContact()
      this.dialogTitle = this.$i18n.t('companies.create_contact')
    }
  }
}
</script>
